export default __webpack_public_path__ + "static/media/6.b40d86e9.png";